export default __webpack_public_path__ + "static/media/Arhive_load_duotone.8c789508.svg";